import { Injectable } from "@angular/core";
import { Preferences } from "@capacitor/preferences";
@Injectable({
    providedIn: "root",
})
export class LocalStorageService {
    /**
     * 로컬 스토리지에 저장된 데이터를 가져옵니다.
     * @param key
     * @returns
     */
    async get<T>(key: string): Promise<T | null> {
        const item = (await Preferences?.get({ key }))?.value;

        if (!item) {
            return null;
        }

        return this.isJSONValid(item) ? (JSON.parse(item) as T) : (item as T);
    }

    /**
     * 로컬 스토리지에 데이터를 저장합니다.
     * @param key
     * @param value
     */
    async set(key: string, value: unknown): Promise<void> {
        await Preferences?.set({
            key,
            value: JSON.stringify(value),
        });
    }

    /**
     * 로컬 스토리지에 저장된 데이터를 삭제합니다.
     * @param key
     */
    async remove(key: string): Promise<void> {
        await Preferences?.remove({ key });
    }

    /**
     * 로컬 스토리지에 저장된 데이터를 삭제합니다.
     * @param keys
     */
    async removeKeys(keys: string[]): Promise<void> {
        await Promise.all(keys.map((key) => Preferences?.remove({ key })));
    }

    /**
     *  로컬 스토리지에 저장된 모든 데이터를 삭제합니다.
     */
    async clear(): Promise<void> {
        await Preferences?.clear();
    }

    private isJSONValid(value: string): boolean {
        try {
            JSON.parse(value);
            return true;
        } catch (error) {
            return false;
        }
    }
}
